import PainsBoard from "./PainsBoard"
import PainsWrite from "./PainsWrite"
import type { Phase } from "@/types"

/*
 * The Pains round has four phases and two screens: writing, then the board.
 *
 * `reveal`, `vote` and `tally` are all the same board in different states, which
 * is why they share a component — see `PainsBoard`.
 *
 * The phase comes in as a prop rather than off the store, because the phase on
 * screen is not always the session's: a finished round can be read back at the
 * beat it was left on — see `useSessionView`.
 */

interface PainsProps {
  phase: Phase
  canDrive: boolean
  readOnly: boolean
}

export default function Pains({ phase, canDrive, readOnly }: PainsProps) {
  if (phase === "write") return <PainsWrite canDrive={canDrive} readOnly={readOnly} />
  return <PainsBoard phase={phase} canDrive={canDrive} readOnly={readOnly} />
}
